var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessingOncolor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0755 6V9L16.1006 5L12.0755 1V4C7.62766 4 4.02515 7.58 4.02515 12C4.02515 13.57 4.48804 15.03 5.27295 16.26L6.74213 14.8C6.27649 13.9395 6.03437 12.977 6.03773 12C6.03773 8.69 8.74464 6 12.0755 6ZM18.878 7.74L17.4088 9.2C17.8516 10.04 18.1132 10.99 18.1132 12C18.1132 15.31 15.4063 18 12.0755 18V15L8.0503 19L12.0755 23V20C16.5233 20 20.1258 16.42 20.1258 12C20.1258 10.43 19.6629 8.97 18.878 7.74Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingOncolor);
export default __webpack_public_path__ + "static/media/processing_oncolor.d68063a5090d3428c6e66dd8b1f62f51.svg";
export { ForwardRef as ReactComponent };